import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchData = async () => {
  const url = apiConstants.url;
  return await apiGet(url);
};

export { fetchData };
